import LoginForm from './login-form.controller';

export default LoginForm;
